var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"z-app-content-light"},[_c('iframe',{attrs:{"width":"100%","height":"600px","src":"/api/index.html"}})])}
var staticRenderFns = []

export { render, staticRenderFns }